export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v1/assets/circle_half_filled-2ba0910eed83266dab98336a7d8d766a.svg";